import React from "react";
import { Route, Switch } from "react-router-dom";
import { Container } from "react-bootstrap";

import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

import NotFound from "./containers/NotFound";
import Home from "./containers/Home";
import Login from "./containers/Login";
import ShowsList from "./containers/ShowsList";
import Show from "./containers/Show";
import ShowAdmissionScanner from "./containers/ShowAdmissionScanner";
import ShowAdmissionList from "./containers/ShowAdmissionList";

export default function Routes() {
  return (
    <Switch>        
        <UnauthenticatedRoute exact path="/login">
            <Container><Login /></Container>
        </UnauthenticatedRoute>
        <AuthenticatedRoute exact path="/">
            <Container fluid><Home /></Container>
        </AuthenticatedRoute>                
        <Route exact path="/shows/past">
            <Container><ShowsList /></Container>
        </Route>
        <AuthenticatedRoute exact path="/shows/:id">
            <Container fluid><Show /></Container>
        </AuthenticatedRoute>        
        <AuthenticatedRoute exact path="/shows/:id/sales">
            <Container fluid><Show /></Container>
        </AuthenticatedRoute>
        <AuthenticatedRoute exact path="/shows/:id/registration">
            <Container fluid><Show /></Container>
        </AuthenticatedRoute>
        <AuthenticatedRoute exact path="/shows/:id/admission/qr">
            <div><ShowAdmissionScanner /></div>
        </AuthenticatedRoute>
        <AuthenticatedRoute exact path="/shows/:id/admission/list">
            <div><ShowAdmissionList /></div>
        </AuthenticatedRoute>

      {/* Finally, catch all unmatched routes */}
        <Route>
            <NotFound />
        </Route>
    </Switch>
  );
}